import StorageKeys from "./StorageKeys";
import events from "./events";

const setItem = ( ...args ) => window.localStorage.setItem( ...args );
const getItem = key => window.localStorage.getItem( key );
const removeItem = key => window.localStorage.removeItem( key );

// NOTE: clear out legacy, unused local storage data; be careful here...
removeItem( StorageKeys.TRANSCRIPTION_STATUS_MASKS );

export default {
	//
	// Configuration
	//
	getConfigOverride() {
		const configOverrideJson = getItem( StorageKeys.TEAMING_CONFIG );
		const config = JSON.parse( configOverrideJson || "{}" );

		// enable teaming global variable: localStorage.setItem( "CREATE_TEAMING_GLOBAL", "1");
		// disable teaming global variable: localStorage.clearItem( "CREATE_TEAMING_GLOBAL" );
		const createTeamingGlobalVariable = !!getItem( StorageKeys.CREATE_TEAMING_GLOBAL );

		// enable vuex logging: localStorage.clearItem( "DISABLE_VUEX_LOGGING" );
		// disable vuex logging: localStorage.setItem( "DISABLE_VUEX_LOGGING", "1");
		const disableVuexLogging = !!getItem( StorageKeys.DISABLE_VUEX_LOGGING );

		return {
			createTeamingGlobalVariable,
			disableVuexLogging,
			...config,
		};
	},

	//
	// Login
	//
	getLoginFlag() {
		return getItem( StorageKeys.LOGGED_IN );
	},
	storeLoginFlag() {
		setItem( StorageKeys.LOGGED_IN, "true" );
	},
	getRedirectToUrl() {
		return getItem( StorageKeys.REDIRECT_TO_URL );
	},
	removeRedirectToUrl() {
		removeItem( StorageKeys.REDIRECT_TO_URL );
	},
	storeRedirectToUrl( url ) {
		setItem( StorageKeys.REDIRECT_TO_URL, url );
	},
	storeRedirectToTarget( target ) {
		setItem( StorageKeys.REDIRECT_TO_TARGET, target );
	},
	getRedirectToTarget() {
		return getItem( StorageKeys.REDIRECT_TO_TARGET );
	},
	removeRedirectToTarget() {
		removeItem( StorageKeys.REDIRECT_TO_TARGET );
	},
	clearLoginFlag() {
		removeItem( StorageKeys.LOGGED_IN );
	},
	isLoggedIn() {
		return this.getLoginFlag() === "true";
	},
	onAuth0TokenChange( cb ) {
		events.on( "*", event => {
			if ( event.key.startsWith( "@@auth0spajs@@" ) ) {
				return cb( event );
			}
		} );
	},

	//
	// Crystal assessment
	//
	getCrystalAssessment() {
		return JSON.parse( getItem( StorageKeys.DISC_CRYSTAL_TEAMING ) );
	},
	storeCrystalAssessment( assessment ) {
		setItem(
			StorageKeys.DISC_CRYSTAL_TEAMING,
			JSON.stringify( { ...assessment, data: assessment.data.data || assessment.data } )
		);
	},
	removeCrystalAssessment() {
		removeItem( StorageKeys.DISC_CRYSTAL_TEAMING );
	},
	onCrystalAssessment( cb ) {
		events.on( StorageKeys.DISC_CRYSTAL_TEAMING, cb );
	},

	//
	// User settings
	//
	// NOTE: this is only temporary for this particular use case, I expect
	// this to be unnecessary in the future, once we have a better bead
	// on cancellation reasons, and a fully fledged cancellation process
	disableCancellationFeature( { personId, } ) {
		setItem( `teaming:${ personId }:showAccountCancellationFeature`, "false" );
	},
	isCancellationFeatureEnabled( { personId, } ) {
		return getItem( `teaming:${ personId }:showAccountCancellationFeature` ) !== "false";
	},

	//
	// Team/1:1 Stream
	//
	expandStreamNavigationSidebar() {
		setItem( StorageKeys.TEAM_STREAM_SIDEBAR_STATE, "1" );
	},
	collapseStreamNavigationSidebar() {
		setItem( StorageKeys.TEAM_STREAM_SIDEBAR_STATE, "0" );
	},
	isStreamNavigationSidebarExpanded() {
		return getItem( StorageKeys.TEAM_STREAM_SIDEBAR_STATE ) !== "0";
	},
};
